import * as React from 'react';
import classNames from 'classnames';
import {NOOP} from 'components/UIKit/utilities';
import {RichIcon} from 'components/UIKit';
import {ImageOptions, Picture} from 'components/UIKit/Picture';
import style from './ListingImage.scss';

export interface ListingImageProps {
  id: string;
  alt?: string;
  type: 'thumbnail' | 'preview' | 'default';
  index?: number;
  active?: boolean;
  imageUrl: string;
  imageOptions: ImageOptions[];
  imageClassName?: string;
  wrapperComponent?: string | React.ComponentClass;
  onClick?: (id: string) => any;
}

interface ListingImageState {
  loaded: boolean;
}

export class ListingImage extends React.Component<ListingImageProps, ListingImageState> {
  constructor(props) {
    super(props);
    this.state = {loaded: false};
  }

  handleClick = () => {
    const {onClick = NOOP, id} = this.props;
    onClick(id);
  };

  componentDidUpdate(prevProps) {
    if (prevProps.imageUrl !== this.props.imageUrl) {
      this.setState({loaded: false});
    }
  }

  handleImageLoad = () => {
    this.setState({loaded: true});
  };

  render() {
    const {
      alt,
      type,
      index,
      active = false,
      imageUrl,
      imageOptions,
      imageClassName,
      wrapperComponent = 'button',
    } = this.props;

    const {loaded} = this.state;
    const Wrapper = wrapperComponent;
    const buttonProps = wrapperComponent === 'button' && {
      type: 'button',
      onClick: this.handleClick,
    };

    const wrapperProps = {
      index,
      className: classNames(style.imageWrapper, style[type], {[style.active]: active}),
      ...(buttonProps && buttonProps),
    };

    return (
      <Wrapper {...wrapperProps}>
        <div className={classNames(style.placeholderWrapper, !loaded && style.showPlaceholder)}>
          <RichIcon icon="noImage" size={40} className={style.placeholder} aria-hidden />
        </div>

        <Picture
          alt={alt || ''}
          imageUrl={imageUrl}
          imageOptions={imageOptions}
          imageClassName={classNames(style.image, imageClassName, loaded && style.loaded)}
          onLoad={this.handleImageLoad}
        />
      </Wrapper>
    );
  }
}

export default ListingImage;
